import React from 'react';
import SpotIllustration from './SpotIllustration';

const NoResultsIllustration = () => {
	const noResultSvg = (
		<SpotIllustration
			spotName="no-results"
			spotWidth="236"
			spotHeight="100"
		/>
	);

	return (
		<div className="text-center mb-4" data-testid="no-results-illustration">
			<div className="my-4" data-testid="no-results-svg">
				{noResultSvg}
			</div>
		</div>
	);
};

export default NoResultsIllustration;
